import type { BonusSpinResult } from '../bonus/types';
import { PAYLINES } from '../core/paylines';
import type { ReplayStepV2 } from '../replay/schema';

/** Builds the complete immutable replay step before any animation begins. */
export function createReplayStep(
  result: BonusSpinResult,
  spinIndex = result.stateAfter.spinsPlayed,
): ReplayStepV2 {
  const newlySticky = result.newStickyWilds;
  return Object.freeze({
    spinIndex,
    stops: result.spin.stops,
    grid: result.spin.grid,
    lineWins: Object.freeze(result.spin.lineWins.map((line) => {
      const route = PAYLINES[line.lineIndex];
      if (route === undefined) throw new RangeError('Eine Replay-Linie verweist auf eine unbekannte Route.');
      return Object.freeze({
        lineIndex: line.lineIndex,
        route,
        count: line.count,
        symbolId: line.symbolId,
        winCents: line.amountCents,
      });
    })),
    spinWinCents: result.spin.totalWinCents,
    cumulativeWinCents: result.stateAfter.totalWinCents,
    scatterCount: result.spin.scatterCount,
    retriggerAwarded: result.retriggerAwarded,
    freeSpinsLeftAfter: result.stateAfter.remainingSpins,
    freeSpinsTotalAfter: result.stateAfter.totalAwardedSpins,
    stickyBefore: result.stickyBefore,
    stickyAfter: result.stickyAfter,
    newlySticky,
    ...(result.pogEffect === null ? {} : { potOfGreed: result.pogEffect }),
    ...(result.godEvents.length === 0 ? {} : { godEvents: result.godEvents }),
  });
}
